import { useEffect } from 'react'

import {
  registerRoleProperties,
  unregisterRoleProperties,
} from '../useAnalytics'

import { MeStateIProps, getRoles } from '@/redux/me/meSlice'

import { mixpanel } from '../mixpanel'

const isAnalyticsIdentify = true

/**
 * `user` is `null` until the `Me` query resolves and `false` after logout
 * (`setMe(false)` in `KeyCloakProvider`).
 */
export const useIdentifyUser = (user: MeStateIProps | false | null) => {
  useEffect(() => {
    if (!isAnalyticsIdentify) return
    // Only an explicit logout clears the roles. While `me` is still loading,
    // the cookie keeps the roles from this browser's last session, so the
    // initial page view still carries them.
    if (user === false) {
      unregisterRoleProperties()
      return
    }
    if (!user) return
    const roles = getRoles(user)
    mixpanel.identify(user.email)
    mixpanel.people.set({
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      role: user.roleName,
      roles,
      userId: user.id,
    })
    registerRoleProperties(user.roleName, roles)
  }, [user])
}
